export const getDialerPlanData = (planMode, allPlans) =>
  (allPlans || []).filter(
    (plan) =>
      plan.planMode === planMode &&
      plan.planCode?.startsWith('dialer') &&
      plan.planCode !== 'dialer-free',
  );
